import SideBarContainer from './SideBarContainer';
import MobileNav from './MobileNav';
import { useMediaQueryContext } from '../shared/context/mediaQueryContext';


function NavBarContainer(props) {

    const { IS_LG, IS_XL, IS_MD, IS_SM, IS_XS } = useMediaQueryContext();

    if (IS_MD || IS_SM || IS_XS) return  <MobileNav />;
    console.log('here');
    return <SideBarContainer />;

}

export default NavBarContainer;
